import React, { Component } from 'react';
import successLogo from './../../../../../../statics/img/esaypaisa/success.svg';
import failLogo from './../../../../../../statics/img/esaypaisa/fail.svg';
import pendingLogo from './../../../../../../statics/img/esaypaisa/pending.svg';
import './status.css';

class Status extends Component {

    renderSuccess = () => (
        <div>
            <img src={successLogo} />
            <h4>Payment successful</h4>
            <p>Thank you for using Forsa.</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} />
            <h4>Payment failed</h4>
            <p>{this.props.status_message != "" ? this.props.status_message : "Insufficient funds."}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} />
            <h4>Payment pending</h4>
            <p>Thank you for using Forsa.</p>
            <p>Your payment is being processed.</p>
        </div>
    )

    render() {
        return (
            <div className="easypaisa_status">
                {this.props.status == "success" && this.renderSuccess()}
                {this.props.status == "fail" && this.renderFail()}
                {this.props.status == "pending" && this.renderPending()}
            </div>
        )
    }
}
export default Status;